import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';

export default {
  digitalizationService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    'revService',
    function (
      runtimeConstant,
      $http,
      $q,
      $filter,
      webApiSettings,
      Revision,
    ) {
      'use strict';

      var loadDigitalizationsDeferred = null;

      function handleError(err, status) {
        //falhou
        if (status === 404 || status === -1) {
          var error = {
            status_code: status,
            error: $filter('translate')('SERVER OFFLINE'),
            error_description: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
          return error;
        }

        if (status === 403) {
          var ex1 = {
            status_code: status,
            error: $filter('translate')('REVISION NOT PUBLIC'),
            error_description: $filter('translate')(
              'REVISION NOT PUBLIC DESCRIPTION'
            ),
          };
          return ex1;
        }

        if (status !== 400) {
          var ex = {
            status_code: status,
            error: $filter('translate')('UNEXPECTED ERROR'),
            error_description:
              err !== null && err !== ''
                ? err.toString()
                : $filter('translate')('UNEXPECTED MESSAGE'),
          };
          return ex;
        }
        return err;
      }

      function cancelLoadDigitalizations() {
        if (loadDigitalizationsDeferred !== null) {
          loadDigitalizationsDeferred.resolve({
            result: [],
            count: 0,
          });

          loadDigitalizationsDeferred = null;
        }
      }

      function loadDigitalizations(page, pageSize) {
        loadDigitalizationsDeferred = $q.defer();

        $http
          .post(
            webApiSettings.apiServiceBaseUri + 'digitalization/waiting',
            {
              Page: page,
              PageSize: pageSize,
            },
            {
              timeout: loadDigitalizationsDeferred.promise,
            }
          )
          .then(
            function (res) {
              var result = [];

              var data = resolveReferences(res.data).Result;
              if (data.length > 0) {
                data.forEach(function (d) {
                  try {
                    var rev = new Revision(d, null);

                    rev.isDigitalization = true;
                    rev.hasViewPermission = false;
                    rev.canView = false;
                    rev.canDownload = true;
                    rev.canDelete = false;
                    rev.canBecomeObsolete = false;
                    rev.canFavorite = false;
                    rev.canSignDocumentD4s = false;
                    rev.canSignCertificate = false;
                    rev.canShowReportDocument = false;
                    rev.canPublicLink = false;
                    rev.canConvertToPdf = false;
                    rev.canShare = false;
                    rev.canSignDocument = false;
                    rev.canReplaceFile = false;
                    rev.canDelete = false;
                    rev.canProperties = true;
                    rev.canAuditDocuments = false;
                    rev.canBecomeObsolete = false;
                    rev.canRestoreDocument = false;
                    rev.canFavorite = false;
                    rev.canUnfavorite = false;
                    rev.canNotifyUsers = false;
                    rev.canCheckout = false;
                    rev.canCheckin = false;
                    rev.canCancelCheckout = false;
                    rev.canLinkDocument = false;
                    rev.canCancelLinkDocument = false;
                    rev.canEditDocumentLink = false;
                    rev.canMovie = false;
                    rev.canShowInFolder = false;

                    result.push(rev);
                  } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error(error);
                  }
                });
              }

              if (loadDigitalizationsDeferred !== null) {
                loadDigitalizationsDeferred.resolve(result);
                loadDigitalizationsDeferred = null;
              }
            },
            function (err) {
              if (err.status === -1) {
                return;
              }

              var error = handleError(err.data, err.status);

              if (loadDigitalizationsDeferred !== null) {
                loadDigitalizationsDeferred.reject(error);
                loadDigitalizationsDeferred = null;
              }
            }
          );

        return loadDigitalizationsDeferred.promise;
      }

      function findDigitalization(id) {
        var deferred = $q.defer();

        $http
          .get(`${webApiSettings.apiServiceBaseUri}digitalization/virtual/${id}`)
          .then((res) => {
            var result = [];

            var data = resolveReferences(res.data).Result;
            if (data.length > 0) {
              data.forEach(function (d) {
                try {
                  var rev = new Revision(d, null);

                  rev.isDigitalization = true;
                  rev.hasViewPermission = false;
                  rev.canView = false;
                  rev.canDownload = true;
                  rev.canDelete = false;
                  rev.canBecomeObsolete = false;
                  rev.canFavorite = false;
                  rev.canSignDocumentD4s = false;
                  rev.canSignCertificate = false;
                  rev.canShowReportDocument = false;
                  rev.canPublicLink = false;
                  rev.canConvertToPdf = false;
                  rev.canShare = false;
                  rev.canSignDocument = false;
                  rev.canReplaceFile = false;
                  rev.canDelete = false;
                  rev.canProperties = true;
                  rev.canAuditDocuments = false;
                  rev.canBecomeObsolete = false;
                  rev.canRestoreDocument = false;
                  rev.canFavorite = false;
                  rev.canUnfavorite = false;
                  rev.canNotifyUsers = false;
                  rev.canCheckout = false;
                  rev.canCheckin = false;
                  rev.canCancelCheckout = false;
                  rev.canLinkDocument = false;
                  rev.canCancelLinkDocument = false;
                  rev.canEditDocumentLink = false;
                  rev.canMovie = false;
                  rev.canShowInFolder = false;

                  result.push(rev);
                } catch (error) {
                  // eslint-disable-next-line no-console
                  console.error(error);
                }
              });
            }

            deferred.resolve(result[0]);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function getFolders() {
        var deferred = $q.defer();

        $http
          .get(webApiSettings.apiServiceBaseUri + 'digitalization/folders')
          .then(
            function (res) {
              deferred.resolve(res.data.folders || res.data);
            },
            function (err) {
              deferred.reject(handleError(err.data, err.status));
            }
          );

        return deferred.promise;
      }

      function getDocumentTypes() {
        var deferred = $q.defer();

        $http
          .get(webApiSettings.apiServiceBaseUri + 'digitalization/documenttypes')
          .then(
            function (res) {
              deferred.resolve(res.data.DocumentTypes || res.data);
            },
            function (err) {
              deferred.reject(handleError(err.data, err.status));
            }
          );

        return deferred.promise;
      }

      function getClassifications() {
        var deferred = $q.defer();

          $http
              .get(webApiSettings.apiServiceBaseUri + 'digitalization/classifications')
              .then(
                function (res) {
                  var data = res.data;

                  deferred.resolve(data.Classifications);
                },
                function (err) {
                  var error = handleError(err.data, err.status);
                  deferred.reject(error);
                }
              );

          return deferred.promise;
      }

      function saveMetadata(payload) {
        var deferred = $q.defer();

        $http
          .post(
            webApiSettings.apiServiceBaseUri + 'digitalization/metadata',
            payload
          )
          .then(
            function (res) {
              deferred.resolve(res.data);
            },
            function (err) {
              deferred.reject(handleError(err.data, err.status));
            }
          );

        return deferred.promise;
      }

      function getMetadatas() {
        var deferred = $q.defer();

        $http
          .get(webApiSettings.apiServiceBaseUri + 'digitalization/metadatas')
          .then(
            function (res) {
              deferred.resolve(res.data.metadatas || res.data);
            },
            function (err) {
              deferred.reject(handleError(err.data, err.status));
            }
          );

        return deferred.promise;
      }

      function deleteMetadata(idDigitalizationClassification) {
        var deferred = $q.defer();

        $http
          .delete(
            webApiSettings.apiServiceBaseUri +
              'digitalization/metadata/' +
              idDigitalizationClassification
          )
          .then(
            function (res) {
              deferred.resolve(res.data);
            },
            function (err) {
              var error = handleError(err.data, err.status);
              deferred.reject(error);
            }
          );

        return deferred.promise;
      }

      function updateMetadata(payload) {
        var deferred = $q.defer();

        $http
          .put(
            webApiSettings.apiServiceBaseUri + 'digitalization/metadata',
            payload
          )
          .then(
            function (res) {
              deferred.resolve(res.data);
            },
            function (err) {
              deferred.reject(handleError(err.data, err.status));
            }
          );

        return deferred.promise;
      }

      function downloadDigitray() {
        var deferred = $q.defer();

        $http
          .get(webApiSettings.apiServiceBaseUri + 'digitalization/digitray/generate')
          .then((result) => {
            var data = result.data;

            top.location.href =
              webApiSettings.apiServiceBaseUri + 'digitalization/digitray/hash/' + data;

            deferred.resolve(true);
          })
          .catch((err) => deferred.reject(err));

        return deferred.promise;
      }

      function run() {
        try {
          var digitalizationServiceFactory = {};

          digitalizationServiceFactory.cancelLoadDigitalizations = logWrapper(
            cancelLoadDigitalizations,
            runtimeConstant.isDebugServicesInternals
          );
          digitalizationServiceFactory.loadDigitalizations = logWrapper(
            loadDigitalizations,
            runtimeConstant.isDebugServicesInternals
          );
          digitalizationServiceFactory.findDigitalization = logWrapper(
            findDigitalization,
            runtimeConstant.isDebugServicesInternals
          );
          digitalizationServiceFactory.getFolders = logWrapper(
            getFolders,
            runtimeConstant.isDebugServicesInternals
          );
          digitalizationServiceFactory.getDocumentTypes = logWrapper(
            getDocumentTypes,
            runtimeConstant.isDebugServicesInternals
          );
          digitalizationServiceFactory.getClassifications = logWrapper(
            getClassifications,
            runtimeConstant.isDebugServicesInternals
          );
          digitalizationServiceFactory.saveMetadata = logWrapper(
            saveMetadata,
            runtimeConstant.isDebugServicesInternals
          );
          digitalizationServiceFactory.getMetadatas = logWrapper(
            getMetadatas,
            runtimeConstant.isDebugServicesInternals
          );
          digitalizationServiceFactory.deleteMetadata = logWrapper(
            deleteMetadata,
            runtimeConstant.isDebugServicesInternals
          );
          digitalizationServiceFactory.updateMetadata = logWrapper(
            updateMetadata,
            runtimeConstant.isDebugServicesInternals
          );
          digitalizationServiceFactory.downloadDigitray = logWrapper(
            downloadDigitray,
            runtimeConstant.isDebugServicesInternals
          );

          return digitalizationServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
